function setTitle (t) {
  document.title = t
  var i = document.createElement('iframe')
  i.src = '//m.baidu.com/favicon.ico'
  i.style.display = 'none'
  i.onload = function () {
    setTimeout(function () {
      i.remove()
    }, 9)
  }
  document.body.appendChild(i)
}
function formatEquipNumber (equipmentNumber) {
  let numberInfo = equipmentNumber.split('-')
  let typeNumber = numberInfo[0]
  let typeAfter = numberInfo[1].substr(-4)
  return typeNumber + '-' + typeAfter
}
function decDigits (num, dig) {
  if (num) {
    return Number(num.toFixed(dig))
  } else {
    return null
  }
}
function timestampLocalToUtc (timestamp, stformat) {
  // eslint-disable-next-line one-var
  let offset = (new Date().getTimezoneOffset()) * 60 * 1000,
    localTimestamp = parseInt(timestamp) + offset
  return timestampToTime(localTimestamp, stformat)
}
function timestampToTime (timestamp, format) {
  var date = new Date(timestamp)
  // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  if (format === 'MM-DD hh-mm') {
    return M + D + h + m
  } else if (format === 'YY-MM-DD') {
    return Y + M + D
  } else if (format === 'YY-MM') {
    return Y + M
  } else if (format === 'YY-MM-DD hh') {
    return Y + M + D + h
  } else if (format === 'hh:mm') {
    return h + m
  } else if (format === 'YY¥MM¥DD') {
    return (date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日')
  } else {
    return Y + M + D + h + m + ':' + s
  }
}
function getUtcTime (time, level) { // 获取utc时间戳的本地时间 格式 '2019-12-05 00:00:00' 要使用leveltime必传
  // 客户端实际时区(例如东京为东九区：-540)
  // let offsetGMT = new Date().getTimezoneOffset()
  // 需要修复的时间，支持字符串传参
  let nowDate = time ? new Date(time).getTime() : new Date().getTime()
  let timeStamp = new Date(nowDate)
  if (!level) return timeStamp.getTime()
  else return parseInt(timeStamp.getTime() / level)
}

function getGMTTime (timeS, level) { // timeStamp 到s级的时间戳 要使用leveltime必传
  if (!timeS) return null
  // 客户端实际时区(例如东京为东九区：-540)
  // let offsetGMT = new Date().getTimezoneOffset()
  // 需要修复的时间，支持字符串传参
  let nowDate = level ? new Date(timeS * level).getTime() : new Date(timeS).getTime()
  let timeStamp = new Date(nowDate)
  return timeStamp.getTime()
}
// 获取当前月份的天数
function mGetDate () {
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var d = new Date(year, month, 0)
  return d.getDate()
}
function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}
function createArr (length) {
  let arr = new Array(length)
  for (let i = 1; i <= length; i++) {
    if (i < 10) {
      arr[i - 1] = {'text': '0' + i + '分钟', value: i}
    } else {
      arr[i - 1] = {'text': i + '分钟', value: i}
    }
  }
  return arr
}
function createDwArr (length) {
  // eslint-disable-next-line no-array-constructor
  let arr = new Array()
  for (let i = 1; i <= length; i++) {
    if (Number(i) % 5 === 0) {
      // console.log('i-------->>>>>>>>' + i)
      if (i < 10) {
        arr.push({'text': '0' + i + '分钟', value: i})
      } else {
        arr.push({'text': i + '分钟', value: i})
      }
    }
  }
  // console.log('arr----------->>>>>' + JSON.stringify(arr))
  return arr
}
function timeToSec (time) {
  var hour = time.split(':')[0]
  var min = time.split(':')[1]
  var s = Number(hour * 3600) + Number(min * 60)
  return s * 1000
}
function maxArr (arr) {
  return Math.max.apply(null, arr)
}
function minArr (arr) {
  return Math.min.apply(null, arr)
}
function ceilMutiple (num) {
  let int = Math.ceil(num)
  let remainder = int % 5
  if (remainder !== 0) {
    return int + (5 - int % 5)
  } else {
    return int
  }
}
function formateDoubleNumber (N) {
  if (typeof N === 'number') {
    if (N < 10) {
      return ('0' + N)
    }
    return N
  }
}
function floorMutiple (num) {
  let int = Math.floor(num)
  let remainder = int % 5
  if (remainder !== 0) {
    return int - int % 5
  } else {
    return int
  }
}
function timestamp () {
  var tmp = Date.parse(new Date()).toString()
  tmp = tmp.substr(0, 10)
  return tmp
}

function getEvn () {
  var _local = window.location.href
  if (!(_local.indexOf('test') > -1 || _local.indexOf('prod') > -1)) {
    return 'local'
  } else if (_local.indexOf('test') > -1) {
    return 'test'
  } else if (_local.indexOf('prod') > -1) {
    return 'prod'
  }
}
function staticHref () {
  var evn = getEvn()
  console.log("evn+++",evn)
  if (evn === 'local') {
    return '/static/'
  } else if (evn === 'test') {
    return '/mydevice/max/test/static/'
  } else if (evn === 'prod') {
    return '/mydevice/max/prod/static/'
  }
}
export default{
  formatEquipNumber,
  timestampToTime,
  getQueryVariable,
  mGetDate,
  close,
  decDigits,
  createArr,
  createDwArr,
  ceilMutiple,
  floorMutiple,
  maxArr,
  minArr,
  setTitle,
  formateDoubleNumber,
  timeToSec,
  timestamp,
  getEvn,
  staticHref,
  getUtcTime,
  getGMTTime,
  timestampLocalToUtc
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js